// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__2N4dM","link":"menu_link__3IF1Q"};